import { useCallback, useContext, useEffect } from 'react';
import { ChatSocketEvent } from '@trinity/chat';
import { GroupFeaturesContext } from '@trinity/chat-components/containers/Chat';
import { useChatSocket } from '@trinity/chat-components/websocket';
import { ActiveChatSessionContext } from './context';

type Props = {
  children: React.ReactNode;
};

export const ChatEventsContainer = (props: Props) => {

  const session = useContext(ActiveChatSessionContext);
  const chatIdentifier = session.identifier;

  const socket = useChatSocket(chatIdentifier);
  const features = useContext(GroupFeaturesContext);
  const enabled = features.deleteChatsOnSessionEnd;

  const handleChatSessionDeleted = useCallback(() => {
    window.location.reload();
  }, []);

  useEffect(() => {
    if (!socket) return;

    if (enabled) {
      socket.on(ChatSocketEvent.ChatDeleted, handleChatSessionDeleted);

      return () => {
        socket.off(ChatSocketEvent.ChatDeleted, handleChatSessionDeleted);
      };
    }
  }, [enabled, handleChatSessionDeleted, chatIdentifier, socket]);

  return (
    <>
      {props.children}
    </>
  );
};
